<template lang="html">
  <div id="notifications" class="uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap">
    <header class="uk-width uk-margin-remove uk-padding-remove uk-heading-line">
      <h3>Komunikaty</h3>
    </header>
    <div class="notificaions-holder uk-width">
      <div v-for="notification in notifications" class="notification uk-width uk-margin-bottom uk-margin-remove-top uk-box-shadow-small uk-box-shadow-hover-large uk-padding uk-grid uk-margin-remove-left uk-padding-small" v-bind:class="{ unread: isRead(notification) }">
        <span class="uk-flex uk-flex-middle uk-width-1-6 uk-padding-remove-horizontal" uk-icon="icon: info; ratio: 1.5;"></span>
        <div class="uk-width-5-6 uk-padding-remove-horizontal">
          <article class="notification-title uk-width" @click="OpenModal(notification.id)">
            {{ notification.messagetxt | truncate(80) }}
          </article>
          <footer class="uk-link-muted uk-width uk-padding-remove-horizontal uk-margin-small-top">
            <span class="time-added">Dodane {{ notification.data | formatDatefrom }}</span>
            |
            <a class="see-more" @click="OpenModal(notification.id)">Zobacz cały komunikat</a>
            <!-- MODAL !-->
            <div v-bind:id="'see-more-modal-' + notification.id" uk-modal>
              <div class="uk-modal-dialog uk-modal-body">
                  <h2 class="uk-modal-title">{{ notification.title }}</h2>
                  <p>{{ notification.messagetxt }}</p>
                  <p class="uk-text-right">
                    <button class="uk-button uk-button-default uk-modal-close" type="button">Zamknij</button>
                    <button v-if="notification.read === false" @click="MarkAsRead(notification.id)" class="uk-button uk-button-danger uk-modal-close" type="button">Przeczytane</button>
                  </p>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
export default {
  name: 'notifications',
  data () {
    return {
      notifications: [
        {
          'title': '',
          'messagetxt': '',
          'data': '',
          'author': '',
          'id': '',
          'read': ''
        }
      ]
    }
  },
  mounted: function () {
    this.loadData()
    this.interval = setInterval(function () {
      this.loadData()
    }.bind(this), 30000)
  },
  methods: {
    MarkAsRead (id) {
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var markReadMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'id': id}}}
        // TODO: API URL z XML
        this.$http.post('/api.php?url=markRead', markReadMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          this.loadData()
        }).catch((errors) => {
          JSON.stringify(errors)
        })
      }
    },
    isRead (notification) {
      if (notification.read === false) {
        return true
      } else {
        return false
      }
    },
    OpenModal (id) {
      UIkit.modal('#see-more-modal-' + id).show()
    },
    loadData: function () {
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var getMessagesMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'reservation_id': null}}}
        // TODO: API URL z XML
        this.$http.post('/api.php?url=getMessages', getMessagesMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          var resp = response.data
          var notifications = resp.d.data
          this.notifications = notifications
        }).catch((errors) => {
          JSON.stringify(errors)
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>

  ::-webkit-scrollbar-thumb
    border-radius: 8px
    border: 2px solid white
    background-color: rgba(0, 0, 0, .5)

  #notifications

    .notificaions-holder
      overflow-y: scroll
      -webkit-overflow-scrolling: touch
      height: 250px
      padding-top: 10px
      padding-right: 5px
      padding-bottom: 10px

    .notification
      cursor: pointer

      footer
        font-size: 70%
        text-align: right

      .notification-title
        font-size: 17px

      // .notification-icon
        height: 100%

      &.unread
        .notification-title
          font-weight: bold
          text-decoration: underline

</style>



// WEBPACK FOOTER //
// notifications.vue?719c234d